jQuery(function(){
    jQuery(document).on('click', '.itinerary-map__cta', function(e){
        var $this = jQuery(this);
        var $container = $this.parent().prev('.itinerary-map__itinerary-container');

        if($container.hasClass('itinerary-map__itinerary-container--hidden')) {
            $container.removeClass('itinerary-map__itinerary-container--hidden');
            $this.html('Close Itinerary');
        } else {
            $container.addClass('itinerary-map__itinerary-container--hidden');
            $this.html('View Full Itinerary');
        }

        return false;

    });


    jQuery(document).on('click', '.itinerary-map__map-cta', function(e){
        var $this = jQuery(this);
        var $container = $this.parent();
        $container.removeClass('itinerary-map__map-container--overlay');

        return false;
    });

});